import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { newTreesAtom, partnerIdAtom } from './atoms'
import { Button } from '@mui/material'
import * as React from 'react'
import { createTreeFromIngestion } from './Utility'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { useCallback } from 'react'

export function CreateTreeButton({ ingestionKey }: { ingestionKey: string }) {
  const createTree = useCreateTreeForKey()
  const doIt = async () => {
    await createTree(ingestionKey)
  }
  return <Button onClick={doIt}>Create Tree</Button>
}

export function useCreateTreeForKey() {
  const partnerKey = useAtomValue(partnerIdAtom)
  const setTrees = useSetAtom(newTreesAtom)
  return useCallback(
    async (ingestionKey: string) => {
      const { curricula } = await createTreeFromIngestion({
        partner_key: partnerKey,
        ingestion_key: ingestionKey,
      })
      setTrees((prev) => [
        ...prev,
        {
          title: ingestionKey,
          ...curricula,
        },
      ])
    },
    [partnerKey, setTrees],
  )
}
